// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent } from "firebase/analytics";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyC6rRhfawwINtNYmi73NLSPRRhJfoKtgAQ",
  authDomain: "legalpage-b84ee.firebaseapp.com",
  projectId: "legalpage-b84ee",
  storageBucket: "legalpage-b84ee.firebasestorage.app",
  messagingSenderId: "306432470139",
  appId: "1:306432470139:web:6f910df641464870ab06de",
  measurementId: "G-ZWGPX5R1BQ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Helper function to log custom events
export const logAnalyticsEvent = (eventName, eventParams = {}) => {
  logEvent(analytics, eventName, eventParams);
};

export { app, analytics };
